import { type FC, useState } from 'react';
import { PlantNavigation } from '@components/Plant/PlantNavigation/PlantNavigation';
import { PlantBurger } from '@components/ui/PlantBurger/PlantBurger';

import { type PlantTypeText } from '@/common/types/plant';
import { GoodsNavigationItem } from '@/components/Goods/GoodsNavigationItem/GoodsNavigationItem';
import { selectGoodsByMaterialRecipe } from '@/redux/selectors/workshopSelectors';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

interface GoodsNavigationProps {
  material: PlantTypeText;
}

const GoodsNavigation: FC<GoodsNavigationProps> = ({ material }) => {
  const [isOpen, setIsOpen] = useState(false);
  const goodsList = useAppSelector((state) =>
    selectGoodsByMaterialRecipe(state, material),
  );

  const onClose = (): void => {
    setIsOpen(false);
  };

  return (
    <>
      <PlantBurger
        onClick={() => setIsOpen(true)}
        className="pointer-events-auto"
      />
      <PlantNavigation
        list={goodsList}
        item={(props) => (
          <GoodsNavigationItem
            key={`${props.id}-${props.goodsName}`}
            {...props}
            onClose={onClose}
          />
        )}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className={css.navPaddingTop}
      />
    </>
  );
};

export { GoodsNavigation };
